import { render, staticRenderFns } from "./BarCodeRulesEdit.vue?vue&type=template&id=ce8fe56c&"
import script from "./BarCodeRulesEdit.vue?vue&type=script&lang=js&"
export * from "./BarCodeRulesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports